import {Base} from '../../common/model/base.model';
import {Helpers} from '../../common/helpers/helpers';
import {Genere} from './genere.enum';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {TipoContratto} from './tipocontratto.enum';
import {EntitaOrganizzativa} from '../entitaorganizzativa/entitaorganizzativa.model';
import {SiperRecapito} from '../../+siper/siperrecapito/siper-recapito.model';
import {ValoreAttributo} from '../../common/model/valoreattributo.model';

export class Persona extends Base {

  constructor(protected id: number,
              public nome: string,
              public cognome: string,
              public matricola: number,
              public sesso: Genere,
              public dataNascita: Date,
              public codiceFiscale: string,
              public username: string,
              public utente: number,
              public dataCessazione: Date,
              public dataPrevistaCessazione: Date,
              public tipoContratto: TipoContratto,
              public contratto: string,
              public livello: string,
              public profilo: string,
              public livelloProfilo: string,
              public dipendente: boolean,
              public sede: EntitaOrganizzativa,
              public siperRecapito: SiperRecapito,
              public valoreAttributoWebDtos: ValoreAttributo[] = undefined,
              public telefonoUfficio: string = undefined) {
    super(id);
  }

  public static getTableKeys() {
    return ['id', 'matricola', 'nome', 'cognome', 'codiceFiscale', 'sede', 'dataCessazione', 'tipoContratto', 'livelloProfilo', 'dipendente'];
  }

  public getDataCessazione() {
    if (this.dataCessazione) {
      return this.dataCessazione;
    }
    return this.dataPrevistaCessazione;
  }


  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('matricola', new TableRowValue(this.matricola, null));
    rowValues.set('nome', new TableRowValue(this.nome, null));
    rowValues.set('cognome', new TableRowValue(this.cognome, null));
    rowValues.set('codiceFiscale', new TableRowValue(this.codiceFiscale, null));
    rowValues.set('sede', new TableRowValue(this.sede ? this.sede.getSigla() : null, null));
    rowValues.set('tipoContratto', new TableRowValue(this.tipoContratto ? this.tipoContratto.getEnumValue() : null, null, true));
    rowValues.set('dataCessazione', new TableRowValue(Helpers.formatDateView(this.getDataCessazione()), null));
    rowValues.set('livelloProfilo', new TableRowValue(this.livelloProfilo, null));
    rowValues.set('contratto', new TableRowValue(this.contratto, null));
    rowValues.set('livello', new TableRowValue(this.livello, null));
    rowValues.set('profilo', new TableRowValue(this.profilo, null));
    rowValues.set('dipendente', new TableRowValue(this.dipendente, null));
    return new TableRow(this, rowValues);
  }

  public getLabel() {
    return Helpers.capitalizeName(this.cognome) + ' '  + Helpers.capitalizeName(this.nome);
  }
}
